import moment from "moment-timezone"
import { useCallback } from "react"
import { useCurrentOrganizationTimeZone } from "source/calendar/hooks/useCurrentOrganizationTimeZone"

export function useMomentInTimeZone() {
  const timeZone = useCurrentOrganizationTimeZone()

  return useCallback((date) => moment.tz(date, timeZone), [timeZone])
}
